import { call, put, takeEvery, all, fork } from 'redux-saga/effects';
import {CREATE_PAYMENT_LINK, CHECK_PAYMENT_STATUS, GET_EXTERNAL_USERS, GET_EXTERNAL_USERS_COUNT} from './actionTypes';
import { createPaymentLinkSuccess, createPaymentLinkFail, checkPaymentStatusSuccess, checkPaymentStatusFail,
    getExternalUsersCountSuccess, getExternalUsersCountFail
} from './actions';
import {
    createPaymentLinkUrl,
    checkPaymentStatusUrl,
    getExternalUsersCountUrl,
    getUsersUrl
} from "../../helpers/fakebackend_helper";
import { showNotification } from "../../components/Common/notification";
import {getUsersFail, getUsersSuccess} from "../organization/actions";

function* onCreatePaymentLink({ payload: { payment_payload } }) {
    try {
        const response = yield call(createPaymentLinkUrl, payment_payload);

        if (response && response.payment_link_url) {
            yield put(createPaymentLinkSuccess(response));
            window.location.href = response.payment_link_url;
        } else {
            showNotification('error', 'Invalid response from server');
            yield put(createPaymentLinkFail('Invalid response format'));
        }
    } catch (error) {
        let errorMessage = 'Failed to create payment link';
        if (error.response && error.response.data && error.response.data.message) {
            errorMessage = error.response.data.message;
        } else if (error.message) {
            errorMessage = error.message;
        }
        showNotification('error', errorMessage);
        yield put(createPaymentLinkFail(errorMessage));
    }
}

function* onCheckPaymentStatus({ payload: { payment_payload } }) {
    try {
        const response = yield call(checkPaymentStatusUrl, payment_payload);
        if (response) {
            yield put(checkPaymentStatusSuccess(response));
        }
    } catch (error) {
        let errorMessage = 'Failed to check payment status';
        if (error.response && error.response.data && error.response.data.message) {
            errorMessage = error.response.data.message;
        } else if (error.message) {
            errorMessage = error.message;
        }
        showNotification('error', errorMessage);
        yield put(checkPaymentStatusFail(errorMessage));
    }
}

function* onGetExternalUsersCount() {
    try {
        const response = yield call(getExternalUsersCountUrl);
        yield put(getExternalUsersCountSuccess(response));
    } catch (error) {
        yield put(getExternalUsersCountFail(error.message));
    }
}

function* subscriptionsSaga() {
    yield takeEvery(CREATE_PAYMENT_LINK, onCreatePaymentLink);
    yield takeEvery(CHECK_PAYMENT_STATUS, onCheckPaymentStatus);
    yield takeEvery(GET_EXTERNAL_USERS_COUNT, onGetExternalUsersCount)
}

export default subscriptionsSaga;